import { initializeSettings, ALL_NAMESPACES } from "../common/index.js";
import ReactComponents from "./src/reactComponents/index.js";
import debugLib from "debug";

// Vite import environment variables
const env = import.meta.env;

declare const __GIT_BRANCH__: string | undefined;
const gitBranch = typeof __GIT_BRANCH__ !== "undefined" ? __GIT_BRANCH__ : undefined;

const envType: "DEV" | "STAGING" | "PROD" = env.DEV ? "DEV" : gitBranch === "staging" ? "STAGING" : "PROD";

const settings = initializeSettings(envType);

if (env.DEV) {
	debugLib.enable(ALL_NAMESPACES);
}

export { settings, ReactComponents };

export {
	names,
	phases,
	generatePlayerID,
	generateQrCode,
	Results,
	log,
	generateRandomString,
	PLAYER_COLORS,
	PLAYER_COLOR_HEX,
	hexToPhaser,
} from "../common/index.js";
export type { PlayerColor } from "../common/index.js";
